import { contentContainerStyle } from '@/components/ui/Layout/ContentContainer/style';
import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { headStyle } from '@/components/ui/Typography/Heading/Head/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineCompleteLayout のスタイル
 */
export const hotlineCompleteLayoutStyle = tv({
    slots: {
        card: [
            'w-full max-w-[830px]',
            'flex flex-col items-center gap-20 lg:gap-32',
            'mx-auto',
            'mb-80 mt-24 lg:mt-32',
            'py-32 px-16 lg:p-32',
        ],
        link: ['group'],
        linkWrap: ['flex flex-wrap gap-24'],
        pageTitleInner: [contentContainerStyle(), 'mx-auto'],
        sectionLeadSentence: [
            textStyle({ color: 'base', size: 'md' }),
            'text-center',
        ],
        sectionTitle: [headStyle({ color: 'base', isBold: true, size: 'xl' })],
    },
});
